export const SKINS = {
    standard: 'standard',
    inverted: 'inverted',
    destructive: 'destructive',
    premium: 'premium',
    dark: 'dark',
    light: 'light',
    transparent: 'transparent',
    premiumLight: 'premium-light',
    ai: 'ai',
};
export const SIZES = {
    tiny: 'tiny',
    small: 'small',
    medium: 'medium',
    large: 'large',
};
export const PRIORITY = {
    primary: 'primary',
    secondary: 'secondary',
};
//# sourceMappingURL=constants.js.map